import React from 'react';
import PropTypes from 'prop-types';
import { treatmentInstanceDialogActions } from '../TreatmentInstanceDialog';
import TreatmentInstanceDialogEdition from '../../../../containers/DailyPlanning/TreatmentInstanceDialog/Edition/TreatmentInstanceDialogEditionContainer';
import TreatmentInstanceDialogCancellation from '../../../../containers/DailyPlanning/TreatmentInstanceDialog/Cancellation/TreatmentInstanceDialogCancellationContainer';
import TreatmentInstanceDialogMoving from '../../../../containers/DailyPlanning/TreatmentInstanceDialog/Moving/TreatmentInstanceDialogMovingContainer';

import { Treatment, TreatmentDefaultProps } from '../../../../propTypes/entities/treatment';
import treatmentInstancePropType from '../../../../propTypes/entities/treatmentInstance';

const TreatmentInstanceDialogContent = ({
  treatment,
  treatmentInstanceId,
  handleClose,
  dateAt,
  cardType,
  treatmentInstance,
  action,
  actionProps,
  changeDialogAction,
  canIteract,
}) => {
  const onBack = () => {
    changeDialogAction(treatmentInstanceDialogActions.EDIT);
  };
  const commonProps = {
    treatment,
    treatmentInstanceId,
    treatmentInstance,
    onClose: handleClose,
    dateAt,
    changeDialogAction,
    onBack,
    canIteract,
  };
  switch (action) {
    default:
    case treatmentInstanceDialogActions.EDIT:
      return (
        <div>
          <TreatmentInstanceDialogEdition {...commonProps} cardType={cardType} {...actionProps} />
        </div>
      );
    case treatmentInstanceDialogActions.CANCEL:
      return (
        <div>
          <TreatmentInstanceDialogCancellation {...commonProps} {...actionProps} />
        </div>
      );
    case treatmentInstanceDialogActions.MOVE:
      return (
        <div>
          <TreatmentInstanceDialogMoving {...commonProps} cardType={cardType} {...actionProps} />
        </div>
      );
  }
};

TreatmentInstanceDialogContent.defaultProps = {
  treatment: TreatmentDefaultProps,
  treatmentInstance: null,
  actionProps: {},
};

TreatmentInstanceDialogContent.propTypes = {
  canIteract: PropTypes.bool.isRequired,
  dateAt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  changeDialogAction: PropTypes.func.isRequired,
  treatment: Treatment,
  treatmentInstanceId: PropTypes.number.isRequired,
  treatmentInstance: treatmentInstancePropType,
  handleClose: PropTypes.func.isRequired,
  cardType: PropTypes.string.isRequired,
  actionProps: PropTypes.shape({
    moveAt: PropTypes.instanceOf(Date),
    movedRiskAssessment: PropTypes.string,
    movedReasonId: PropTypes.number,
    newOrgUnit: PropTypes.number,
  }),
};

export default TreatmentInstanceDialogContent;
